// extracted by mini-css-extract-plugin
module.exports = {"mapStyles":"DepartmentMap_mapStyles__2XNvv","infoWindow":"DepartmentMap_infoWindow__1vMzi"};